/**
 * GroupChatPage - Placeholder for newsroom feature
 * Note: Still named GroupChatPage for backward compatibility
 */

import { ComingSoonPage } from './ComingSoonPage'

export function GroupChatPage() {
  return <ComingSoonPage feature="Newsroom" icon="📰" />
}
